let observer = null;
export function imgLazyLoad(rootMargin = '300px 0px') {
  if (typeof window === 'undefined') return;
  if (observer) {
    observer.disconnect() // 先清除已存在的
  }

  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target
        const src = img.getAttribute('data-src')

        if (src) {
          img.src = src
          img.removeAttribute('data-src')
        }

        observer.unobserve(img)
      }
    })
  }, {
    rootMargin, // 默认提前300px加载
    threshold: 0.01
  })

  // 监听所有带 .lazy-img 的图片
  document.querySelectorAll('.lazy-img').forEach(img => {
    observer.observe(img)
  })

  return observer
}

export function destroyImgLazyLoad() {
  if (observer) {
    observer.disconnect()
    observer = null
  }
}